import { useContext } from 'react';
import { GiftOrdersContext } from '../../data/giftOrdersContexts';
import { useGiftOrdersListEffect } from './useGiftOrdersListEffect';
import { giftOrdersDatagridColumns } from 'modules/support-gift-orders/data/giftOrdersDatagridColumns';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useGiftOrdersList = () => {
  // Obtener el contexto del módulo y sus propiedades
  const giftOrdersContext = useContext(GiftOrdersContext);

  // Desestructuración de las propiedades del contexto
  const { reduxProps, reducerProps } = giftOrdersContext || {};

  // Desestructuración de las propiedades del Redux
  const { getGiftOrders, getGiftOrdersDetailAction } = reduxProps || {};
  const { response } = getGiftOrders || {};
  const { result, pagination } = response || {};
  const location = useLocation();
  const queryFilters = new URLSearchParams(location.search);

  // Desestructuración de las propiedades del Reducer
  const { giftOrdersReducer, dispatchGiftOrdersReducer } = reducerProps || {};
  const {
    rows,
    rowCount,
    columns,
    datagridPage,
    datagridPageSize,
    datagridPageCounter,
    queryParams,
    loadingDatagrid,
  } = giftOrdersReducer;

  // LIST Datagrid Methods:

  useEffect(() => {
    if (pagination) {
      dispatchGiftOrdersReducer({
        property: 'rowCount',
        value: pagination.total_rows,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination]);

  // Función que cambia la página del datagrid
  const changePage = (newPage) => {
    dispatchGiftOrdersReducer({
      property: 'datagridPage',
      value: newPage,
    });
    dispatchGiftOrdersReducer({
      property: 'searchClicked',
      value: true,
    });

    let params = '';

    if (queryParams !== '') {
      params = new URLSearchParams(queryParams);
    } else {
      params = queryFilters;
    }

    params.set('page', newPage);
    params.set('size', datagridPageSize);

    window.history.replaceState(null, '', `/sales/gift-orders?${params.toString()}`);
  };

  // Función que cambia el tamaño de la página (número de rows x pág.) del datagrid
  const changePageSize = (newPageSize) => {
    dispatchGiftOrdersReducer({
      property: 'datagridPageSize',
      value: newPageSize,
    });
    dispatchGiftOrdersReducer({
      property: 'searchClicked',
      value: true,
    });

    let params = '';

    if (queryParams !== '') {
      params = new URLSearchParams(queryParams);
    } else {
      params = queryFilters;
    }

    params.set('size', newPageSize);
    params.set('page', datagridPage);

    window.history.replaceState(null, '', `/sales/gift-orders?${params.toString()}`);
  };

  // Función que se llamará al dar clic al detalle de una orden de regalo
  const handleActionOrderDetail = (order_id) => {
    getGiftOrdersDetailAction({ order_id });

    dispatchGiftOrdersReducer({
      property: 'loadingDatagrid',
      value: false,
    });
  };

  // Función que genera las columnas del datagrid
  const generateDatagridColumns = () => {
    const giftOrdersCols = giftOrdersDatagridColumns({
      handleActionOrderDetail,
    });

    dispatchGiftOrdersReducer({
      property: 'columns',
      value: giftOrdersCols,
    });
  };

  // Función que genera las filas del datagrid
  const generateDatagridRows = () => {
    const giftOrdersRows = [];

    if (result) {
      result?.forEach((element) => {
        giftOrdersRows.push(element);
      });
    }

    dispatchGiftOrdersReducer({
      property: 'rows',
      value: giftOrdersRows,
    });
  };

  // Objeto con las propiedades de paginación del datagrid
  const giftOrdersDatagridValues = {
    changePage,
    changePageSize,
    datagridPageSize,
    page: datagridPage,
    paginationState: {
      paginationModel: {
        page: 0,
        pages: 3,
        pageSize: datagridPageSize,
        rowCount: rowCount,
      },
    },
  };

  // LIST Datagrid UseEffects:
  // Hook que se encarga de manejar la funcionalidad con base a los cambios de estados:
  // @param {Object} generateDatagridColumns - Función para definir las columnas del datagrid
  // @param {Object} generateDatagridRows - Función para definir las filas del datagrid
  useGiftOrdersListEffect({
    generateDatagridColumns,
    generateDatagridRows,
  });

  // Propiedades / variables / estados y métodos / funciones que se usarán en los componentes
  return {
    rows,
    rowCount,
    columns,

    datagridPage,
    datagridPageSize,
    datagridPageCounter,

    loadingDatagrid,

    changePage,
    changePageSize,

    giftOrdersDatagridValues,
  };
};
